/* tslint:disable */

/**
 */
export class VehicleLogView {
    data?: string;
}
